export const apiURL = "";
export const basePath = "api";
export const apiKey = process.env.REACT_APP_API_KEY || "6396bc9743672a772ca2d6062be5371e863b38a3cbf0f88ca6cec7a51f47689c";
export const apiHost = process.env.REACT_APP_API_HOST || "https://api-endpoint-qmgcrroeaa-as.a.run.app";
export const refreshInternal = 10000; // 10 seconds

console.log('apikey', apiKey, apiHost);